import React from 'react';
import PropTypes from 'prop-types';

import colors from '@utils/colors';
import { Facebook, Instagram, Twitter, Youtube, TikTok, Pinterest } from '@components/Icon';
import { BlobOne, BlobTwo, BlobThree, BlobFour } from '@components/vector';

import * as styled from './styles';

function SocialLink({ type, url, blob = true, className }) {
  const getBlob = (type) => {
    switch (type) {
      case 'facebook':
        return <BlobOne color={colors.B100} />;
      case 'twitter':
        return <BlobTwo color={colors.B100} />;
      case 'instagram':
        return <BlobThree color={colors.B100} />;
      case 'youtube':
        return <BlobFour color={colors.B100} />;
      // no default
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case 'facebook':
        return <Facebook size={blob ? '16' : '32'} />;
      case 'twitter':
        return <Twitter size={blob ? '16' : '32'} />;
      case 'x':
        return <Twitter size={blob ? '16' : '32'} />;
      case 'instagram':
        return <Instagram size={blob ? '16' : '32'} />;
      case 'youtube':
        return <Youtube size={blob ? '16' : '32'} />;
      case 'pinterest':
        return <Pinterest size={blob ? '16' : '32'} />;
      case 'tiktok':
        return <TikTok size={blob ? '16' : '32'} />;
      // no default
    }
  };

  return (
    <styled.Blob href={url} target="_blank" rel="noopener noreferrer" aria-label={type} className={className}>
      <styled.Backdrop>
        {blob && getBlob(type)}
      </styled.Backdrop>
      {getIcon(type)}
    </styled.Blob>
  );
}

SocialLink.propTypes = {
  type: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default SocialLink;
